import Vue from 'vue';
import store from './../../store';
import warehouseTransformer from './../../transformers/warehouse';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const warehouses = warehouseTransformer.fetchCollection(data.data);

  store.dispatch('FetchAllWarehouses', warehouses);
  resolve(warehouses);
};

const failed = () => {
};

export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/warehouses', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/warehouse/all.js